module.exports = __webpack_public_path__ + "img/nfk.99af5a94.svg";